import React, { Component } from "react";
import { v4 } from "uuid";
import Modal from "react-bootstrap/Modal";

import "./ViewTemplate.scss";
import ViewTemplateHeader from "./Template/ViewTemplateHeader";
import ViewTemplateFooter from "./Template/ViewTemplateFooter";
import ViewMode from "./ViewMode/ViewMode";

class NewTemplate extends Component {
  state = {
    content: this.props.content,
    activeTab: null,
    activeTabSection: [],
    currentTabName: "",
    currentSection: null,
    editView: false,
    showTabDeleteModal: false,
    errors: {},
    hideIcon : true,
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (this.props.editTemplate) {
        this.setState({
          content: this.props.content,
          activeTab: this.props.content[0].tabId,
          activeTabSection: this.props.content[0].tabSections,
          currentTabName: this.props.content[0].tabTitle,
          currentSection: this.props.content[0].tabSections[0].sectionId,
          editView: true,
        });
      } else {
        this.setState(
          {
            content: this.props.content,
            activeTab: null,
            activeTabSection: [],
            currentTabName: "",
            currentSection: null,
            editView: true,
            errors: {},
          },
          () => {
            this.addTabHandler();
          }
        );
      }
    }

  }

  
  changeTabHandler = (id, tabSection) => {
    let updatedContent = [...this.state.content];
    let tabName;
    let sectionId = null;
    const updatedsection = updatedContent.map((item) => {
      let resultcontent = item;
      if (item.tabId === this.state.activeTab) {
        resultcontent.tabSections = this.state.activeTabSection;
      }
      if (id === item.tabId) {
        tabName = item.tabTitle;
        if (item.tabSections.length > 0) {
          sectionId = item.tabSections[0].sectionId;
        }
      }
      return resultcontent;
    });
    this.setState({
      content: updatedsection,
      activeTab: id,
      activeTabSection: tabSection,
      currentTabName: tabName,
      currentSection: sectionId,
      showTabDeleteModal: false,
    });
  };

  
  toggleEditHandler = () => {
    this.validate();
    // const content = this.updateContent();
    const editView = true;
    this.setState({ editView });
  };

  toggleViewHandler = () => {
    this.validate();
    // const content = this.updateContent();
    if (this.hasValidValue()) {
      const editView = false;
      this.setState({ editView });
    }
  };
  
  addTabHandler = () => {
    const tabId = v4();
    const sectionId = v4();
    const fieldId = v4();
    // default TextField
    const sectionFields = [
      {
        fieldId: fieldId,
        fieldLabel: "",
        inputType: "TextField",
        fieldRequired: false,
        fieldPlaceHolder: "",
      },
    ];
    // default SectionField
    const tabSection = [
      {
        sectionId: sectionId,
        sectionTitle: "",
        sectionFields: sectionFields,
      },
    ];

    const updatedTab = [
      ...this.state.content,
      {
        tabId: tabId,
        tabTitle: "Tab Name",
        tabSections: tabSection,
      },
    ];
    this.changeTabHandler(tabId, tabSection);

    let element = this.state.errors;
    element[tabId] = false;
    element[sectionId] = false;
    this.setState({
      content: updatedTab,
      currentTabName: "",
      currentSection: sectionId,
      errors: element,
    });
  };


     
  templateDeleteOpenHandler = (e) => {
    this.props.templateDeleteOpenHandler(this.props.editTemplateId,this.props.templateTitle)

  }

  templateEditHandler = (e) =>{
  
    this.props.templateEditHandler(e,this.props.editTemplateId)
  }

  render() {
    return (
      <Modal
        className="create-template-modal"
        size="xl"
        centered
        show={this.props.displayViewModal}
        onHide={this.props.templateViewCloseHandler}
      >
        <ViewTemplateHeader
          templateViewCloseHandler={this.props.templateViewCloseHandler}
        />

        <div className="body">
          
            <ViewMode
              editView={this.state.editView}
              content={this.state.content}
              changeTabHandler={this.changeTabHandler}
              activeTab={this.state.activeTab}
              toggleEditHandler={this.toggleEditHandler}
              toggleViewHandler={this.toggleViewHandler}
              hideIcon = {this.state.hideIcon}
              
            />
    
        </div>

        <ViewTemplateFooter
          templateViewCloseHandler={this.props.templateViewCloseHandler}
          draftTemplateHandler={this.draftTemplateHandler}
          createTemplateHandler={this.createTemplateHandler}
          editTemplate={this.props.editTemplate}
          templateDeleteOpenHandler = {this.templateDeleteOpenHandler}
          templateEditHandler = {this.templateEditHandler}
        />
      
        
      </Modal>
    );
  }
}

export default NewTemplate;
